import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { usePage } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import { EntityProps } from 'client/types'
import CommonContentTable from 'common/components/entities/ContentTable'
import { getProcessedHeadlines } from 'common/components/entities/ContentTable/utils'
import { ContentTableInterface } from 'common/types/entities/ContentTableInterface'
import React from 'react'
import BaseEntityNew from '../core/BaseEntity/BaseEntityNew'

function ContentTable({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<ContentTableInterface>) {
  const { isMobile } = useDeviceModeContext()
  const headings = usePage(page =>
    pageSelectors.getOrderedByPositionHeadings(page, isMobile),
  )

  const processedHeadlines = getProcessedHeadlines({ headings, entity })

  const defaultState =
    typeof entity.isOpenedByDefault === 'boolean'
      ? !entity.isOpenedByDefault
      : false

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonContentTable
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
        iconClassName={entity.iconClassName}
        closedIconClassName={entity.closedIconClassName}
        processedHeadlines={processedHeadlines}
        defaultState={defaultState}
        iconColor={entity.iconColor}
        backgroundColor={entity.backgroundColor}
        mobileBackgroundColor={entity.mobileBackgroundColor}
        contentFontFamily={entity.contentFontFamily}
        contentFontStyle={entity.contentFontStyle}
        contentFontWeight={entity.contentFontWeight}
        contentColor={entity.contentColor}
        contentFontSize={entity.contentFontSize}
        contentItemGap={entity.contentItemGap}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
        headerTitle={entity.headerTitle}
        headerFontSize={entity.headerFontSize}
        headerColor={entity.headerColor}
        headerFontFamily={entity.headerFontFamily}
        headerFontStyle={entity.headerFontStyle}
        headerFontWeight={entity.headerFontWeight}
      />
    </BaseEntityNew>
  )
}

export default ContentTable
